import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Navbar height
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'COMPRA Y VENTA',
    action: () => scrollToSection('compra-venta')
  }, {
    name: 'ALQUILER PARA APPS',
    action: () => scrollToSection('alquiler')
  }, {
    name: 'CONSIGNACIÓN',
    action: () => scrollToSection('consignacion')
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md border-b border-brand-gold/20 py-4' : 'bg-transparent py-6'}`} data-id="element-307">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-308">
        <Link to="/" onClick={() => window.scrollTo(0, 0)} data-id="element-309">
          <Logo data-id="element-310" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-311">
          {navLinks.map(link => <button key={link.name} onClick={link.action} className="text-sm font-medium text-brand-white/80 hover:text-brand-gold transition-colors tracking-wide" data-id="element-312">
              {link.name}
            </button>)}
          <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" className="text-sm font-medium text-brand-white/80 hover:text-brand-gold transition-colors tracking-wide" data-id="element-313">
            INVERSIONES
          </a>
          <button onClick={() => scrollToSection('contacto')} className="px-6 py-2.5 bg-brand-gold text-brand-black font-bold text-sm rounded hover:bg-brand-white transition-colors ml-4" data-id="element-314">
            CONTACTANOS
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-brand-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-315">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-316" /> : <Menu className="w-6 h-6" data-id="element-317" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-brand-black border-b border-brand-gold/20 p-6 flex flex-col gap-6 shadow-2xl" data-id="element-318">
          {navLinks.map(link => <button key={link.name} onClick={link.action} className="text-left text-lg font-medium text-brand-white hover:text-brand-gold transition-colors" data-id="element-319">
              {link.name}
            </button>)}
          <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" onClick={() => setIsMobileMenuOpen(false)} className="text-left text-lg font-medium text-brand-white hover:text-brand-gold transition-colors" data-id="element-320">
            INVERSIONES
          </a>
          <button onClick={() => scrollToSection('contacto')} className="w-full py-3 bg-brand-gold text-brand-black font-bold rounded mt-4" data-id="element-321">
            CONTACTANOS
          </button>
        </div>}
    </nav>;
}